/*
 * @Author: 小周
 * @Date: 2023-09-06 12:01:35
 * @LastEditTime: 2024-08-02 16:28:22
 * @LastEditors: MrZHLF
 * @Description:
 */
import { RouterProvider } from 'react-router-dom'
import routerConfig from './router'
import './styles/index.scss'
import * as vConsole from 'vconsole'
import { appWxShare } from './weChat/index'
import useViewDxTrack from './hooks/useViewDxTrack'
import { getAppDoNotLoginUserInfo } from '@/oauth/appLogin'
const App = () => {
  var linkUrl = document.createElement('link')
  var scriptUrl = document.createElement('script')
  linkUrl.rel = 'stylesheet'
  if (process.env.NODE_ENV == 'production') {
    // css文件
    linkUrl.href =
      'https://res.hntv.tv/newlogin/login.css?v=' + new Date().getTime()
    document.head.appendChild(linkUrl)

    // js文件
    scriptUrl.src =
      'https://res.hntv.tv/newlogin/main.js?v=' + new Date().getTime()
    document.body.appendChild(scriptUrl)
  } else {
    // css文件
    linkUrl.href =
      'https://pre-res.hntv.tv/newlogin/login.css?v=' + new Date().getTime()
    document.head.appendChild(linkUrl)
    // js文件
    scriptUrl.src =
      'https://pre-res.hntv.tv/newlogin/main.js?v=' + new Date().getTime()
    document.body.appendChild(scriptUrl)
  }

  if (process.env.NODE_ENV != 'production') {
    new vConsole()
  }

  appWxShare()
  useViewDxTrack()
  getAppDoNotLoginUserInfo()
  return <RouterProvider router={routerConfig} />
}

export default App
